
import { computed, defineComponent, onMounted } from "vue";

import {
  ColumnDefinition,
  BaseTable,
  BaseButton,
  DeleteIcon,
  EditIcon,
} from "@tager/admin-ui";
import { Page } from "@tager/admin-layout";
import { useResource, useResourceDelete } from "@tager/admin-services";

import { deleteTerm, getTermList } from "@/services/requests";
import { TermType } from "@/typings/model";
import { getTermFormUrl, getTermListUrl } from "@/utils/paths";

const COLUMN_DEFS: Array<ColumnDefinition<TermType>> = [
  {
    id: 1,
    name: "Слово",
    field: "term",
  },
  {
    id: 2,
    name: "Значение",
    field: "value",
  },
  {
    id: 3,
    name: "Ссылки",
    field: "linkToLinks",
    style: { whiteSpace: "nowrap", textAlign: "center", width: "130px" },
  },
  {
    id: 4,
    name: "Actions",
    field: "actions",
    style: { width: "180px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "180px", textAlign: "center" },
  },
];

export default defineComponent({
  name: "TermList",
  components: {
    Page,
    BaseTable,
    BaseButton,
    DeleteIcon,
    EditIcon,
  },
  setup() {
    const [fetchTermList, { data: termList, loading: isTermLoading, error }] =
      useResource<Array<TermType>>({
        fetchResource: getTermList,
        initialValue: [],
        resourceName: "Term list",
      });

    onMounted(() => {
      fetchTermList();
    });

    const { handleResourceDelete: handleTermDelete, isDeleting } =
      useResourceDelete({
        deleteResource: deleteTerm,
        resourceName: "Term",
        onSuccess: fetchTermList,
      });

    const isRowDataLoading = computed<boolean>(() => isTermLoading.value);

    function isBusy(termId: number): boolean {
      return isDeleting(termId) || isRowDataLoading.value;
    }

    function getLinkToLinkList(termId: number): string {
      return `${getTermListUrl()}/${termId}/links`;
    }

    return {
      columnDefs: COLUMN_DEFS,
      rowData: termList,
      isRowDataLoading,
      errorMessage: error,
      isBusy,
      handleTermDelete,
      getTermFormUrl,
      getLinkToLinkList,
    };
  },
});
